var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoCircleLinedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1800_6102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.5C7.24162 3.5 7.4375 3.69588 7.4375 3.9375V7.6125C7.4375 7.85412 7.24162 8.05 7 8.05C6.75838 8.05 6.5625 7.85412 6.5625 7.6125V3.9375C6.5625 3.69588 6.75838 3.5 7 3.5Z",
    fill: "#66B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37197 9.65533C7.59646 9.85738 7.61466 10.2032 7.41261 10.4277L7.40649 10.4345C7.20444 10.659 6.85866 10.6772 6.63416 10.4751C6.40966 10.2731 6.39146 9.92728 6.59351 9.70278L6.59964 9.69598C6.80168 9.47148 7.14747 9.45328 7.37197 9.65533Z",
    fill: "#66B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.20312C3.79847 1.20312 1.20312 3.79847 1.20312 7C1.20312 10.2015 3.79847 12.7969 7 12.7969C10.2015 12.7969 12.7969 10.2015 12.7969 7C12.7969 3.79847 10.2015 1.20312 7 1.20312ZM0.546875 7C0.546875 3.43604 3.43604 0.546875 7 0.546875C10.564 0.546875 13.4531 3.43604 13.4531 7C13.4531 10.564 10.564 13.4531 7 13.4531C3.43604 13.4531 0.546875 10.564 0.546875 7Z",
    fill: "#66B6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1800_6102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoCircleLinedBlue);
export default __webpack_public_path__ + "static/media/ic_info_circle_lined_blue.b5a11d0926345d3f3cb6af5d108d2015.svg";
export { ForwardRef as ReactComponent };